import React from 'react';

const LoadingSkeleton = () => {
  return (
    <div className="space-y-4">
      {Array?.from({ length: 5 })?.map((_, i) => (
        <div key={i} className="bg-white bg-opacity-10 backdrop-blur-sm border border-white border-opacity-20 rounded-xl p-6">
          <div className="flex items-start justify-between">
            <div className="flex-1 space-y-3">
              <div className="flex items-center space-x-3">
                <div className="h-6 bg-white bg-opacity-20 rounded shimmer w-48"></div>
                <div className="h-5 bg-white bg-opacity-20 rounded-lg shimmer w-24"></div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div className="h-4 bg-white bg-opacity-20 rounded shimmer w-full"></div>
                <div className="h-4 bg-white bg-opacity-20 rounded shimmer w-full"></div>
                <div className="h-4 bg-white bg-opacity-20 rounded shimmer w-full"></div>
              </div>
              <div className="flex items-center space-x-4">
                <div className="h-3 bg-white bg-opacity-20 rounded shimmer w-20"></div>
                <div className="h-3 bg-white bg-opacity-20 rounded shimmer w-24"></div>
              </div>
            </div>
            <div className="w-10 h-10 bg-white bg-opacity-20 rounded-lg shimmer"></div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default LoadingSkeleton;